import { forwardRef } from 'react'

import { SENTIMENT_BORDER } from './sentimentBorder'
import type { SentimentIconProps } from './types'

const FILL = 'var(--hsds-token-color-blue-accent, #47A3FF)'
const PATH =
  'M8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7H7.58594L5.29297 9.29297C4.90244 9.68349 4.90244 10.3165 5.29297 10.707C5.6835 11.0975 6.31652 11.0975 6.70703 10.707L9 8.41406V10C9 10.5523 9.44772 11 10 11C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5H6Z'

// Improving sentiment (trend) — blue circle with a diagonal up-right arrow.
// The `border` variant renders the same glyph in a 20×20 box behind a white
// border so it reads on colored backgrounds (mirrors the Figma `Border=True` asset).
const ImprovingSentimentIcon = forwardRef<SVGSVGElement, SentimentIconProps>(
  function ImprovingSentimentIcon({ border = false, ...rest }, ref) {
    if (border) {
      return (
        <svg
          ref={ref}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          {SENTIMENT_BORDER}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            transform="translate(2 2)"
            d={PATH}
            fill={FILL}
          />
        </svg>
      )
    }

    return (
      <svg
        ref={ref}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path fillRule="evenodd" clipRule="evenodd" d={PATH} fill={FILL} />
      </svg>
    )
  }
)

export { ImprovingSentimentIcon }
